const processPointCoordinates = (pointsArray) => {
  // 点坐标处理
  const paintArray = [];
  paintArray[0] = [pointsArray[0], pointsArray[1]];
  paintArray[1] = [pointsArray[2], pointsArray[1]];
  paintArray[2] = [pointsArray[2], pointsArray[3]];
  paintArray[3] = [pointsArray[0], pointsArray[3]];
  return paintArray;
};

const processExpregPosition = (pointsArray, angle) => {
  // 点坐标处理
  const paintArray = [];
  if (angle === 0) {
    paintArray[0] = [pointsArray[1], pointsArray[0]];
    paintArray[1] = [pointsArray[1] + pointsArray[3], pointsArray[0]];
    paintArray[2] = [
      pointsArray[1] + pointsArray[3],
      pointsArray[0] + pointsArray[2]
    ];
    paintArray[3] = [pointsArray[1], pointsArray[0] + pointsArray[2]];
  } else {
    paintArray[0] = [pointsArray[0], pointsArray[1]];
    paintArray[1] = [pointsArray[0] + pointsArray[2], pointsArray[1]];
    paintArray[2] = [
      pointsArray[0] + pointsArray[2],
      pointsArray[1] + pointsArray[3]
    ];
    paintArray[3] = [pointsArray[0], pointsArray[1] + pointsArray[3]];
  }
  return paintArray;
};

const rangeFacePropertyResult = (emotion) => {
  const emotionMap = {
    happy: '开心',
    neutral: '自然'
  };
  return [
    {
      key: '表情',
      value: emotionMap[emotion.type]
    },
    {
      key: '置信度',
      // eslint-disable-next-line radix
      value: `${parseInt(emotion.confidence * 100)}%`
    }
  ];
};
const rangeBodyPropertyResult = (body) => {
  return [
    {
      key: '置信度',
      // eslint-disable-next-line radix
      value: `${parseInt(body.confidence * 100)}%`
    },
    {
      key: '举手置信度',
      // eslint-disable-next-line radix
      value: body.property ? `${parseInt(body.property.hand_up * 100)}%` : 0
    }
  ];
};

const processFaceCandidate = (rectangle) => {
  const paintArray = [];
  paintArray[0] = [rectangle.x, rectangle.y];
  paintArray[1] = [rectangle.x + rectangle.width, rectangle.y];
  paintArray[2] = [
    rectangle.x + rectangle.width,
    rectangle.y + rectangle.height
  ];
  paintArray[3] = [rectangle.x, rectangle.y + rectangle.height];
  return paintArray;
};

const exchangeArray2Obj = (array) => {
  const obj = {};
  if (Array.isArray(array)) {
    array.map((item) => {
      // eslint-disable-next-line radix
      obj[item.person_id] = parseInt(item.similarity * 100);
      return null;
    });
  }
  return obj;
};

export const handsGestureResp = (data) => {
  const processArgs = [];
  if (Array.isArray.call(null, data.data)) {
    data.data.map((tar) => {
      processArgs.push({
        points: processPointCoordinates(tar.bbox),
        originPoints: tar.bbox,
        text: tar.hand_gesture
      });
      return null;
    });
  }
  return { processArgs, data };
};
/* eslint-disable */
// eslint-disable-next-line function-paren-newline
export const handsRecognizeFaceResp = (data) => {
  const faceList = data.result.face_list;
  const processArgs = [];
  if (Array.isArray(faceList)) {
    faceList.map((face) =>
      processArgs.push({
        points: processFaceCandidate(face.face_rectangle),
        candidate: exchangeArray2Obj(face.candidate)
      })
    );
  }
  return {
    processArgs,
    data
  };
};
/* eslint-disable */
export const handleFacePropertyResp = (data) => {
  const faseProps = data.data.result.data;
  const processArgs = [];
  if (Array.isArray(faseProps)) {
    faseProps.map((face, index) => {
      processArgs[index] = {
        points: processFaceCandidate(face.face_rectangles),
        text: rangeFacePropertyResult(face.properties.emotion),
        light: data.data.result.lightness
      };
      return null;
    });
  }
  return {
    processArgs,
    data: data.data.result
  };
};

export const handleBodyDetectResp = (data) => {
  const bodyRects = data.data.body_rectangles;
  const processArgs = [];
  if (Array.isArray(bodyRects)) {
    bodyRects.map((body, index) => {
      processArgs[index] = {
        points: processFaceCandidate(body),
        text: rangeBodyPropertyResult(body)
      };
      return null;
    });
  }
  return {
    processArgs,
    data: data.data.result
  };
};

export const handleExpregResp = (data) => {
  const resp = data.data;
  const processArgs = [];
  const { regResult } = resp;
  if (Array.isArray(regResult)) {
    regResult.map((item) => {
      processArgs.push({
        points: processExpregPosition(item.pos, resp.angle),
        text: item.text,
        result: item.judge
      });
      return null;
    });
  }
  return {
    processArgs,
    data: resp,
    serverWidth: resp.width
  };
};
